/**
 * Migrated by mariushirjanu on 07/07/2020.
 */
import { Component, Input } from '@angular/core';

@Component({
  selector: 'location-info',
  template: `
    <div *ngIf="location?.companyCountry?.company?.name">{{location.companyCountry.company.name}}</div>
    <div *ngIf="location?.address">{{location.address}}</div>
    <div *ngIf="location?.zipCode || location?.city">{{location.zipCode}} {{location.city}}</div>
    <div *ngIf="location?.state">{{location.state.name}}</div>
    <div *ngIf="location?.companyCountry?.country?.name">{{location.companyCountry.country.name}}</div>
    <div *ngIf="location?.vatNumber"><span translate>{{vatName || \'GA.GENERAL.VATTAX\'}}</span>: {{location.vatNumber}}</div>
  `
})
export class LocationInfoComponent {
  // bindings
  @Input() public location:any;
  @Input() public vatName:string;

  constructor() {
    /***/
  }
}